import * as constants from '../constants';

export function setLoading(loading) {
    return {
        type: constants.ACTION_TYPE_GLOBAL__SET_LOADING,
        data: { loading }
    };
}